// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-85088db2] .text-link {
  padding-top: 6px;
  padding-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/side-nav/CommunitySideNav.vue","webpack://./CommunitySideNav.vue"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,mBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n:deep(.text-link) {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n",":deep(.text-link) {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
